
export const options = [
    { value: 'Comedy', image: 'comedy.jpg' },
    { value: 'Sci-Fi', image: 'sci-fi.jpg' },
    { value: 'Horror', image: 'horror.jpg' },
    { value: 'Romance', image: 'romance.jpg' },
    { value: 'Action', image: 'action.jpg' },
    { value: 'Thriller', image: 'thriller.jpg' },
    { value: 'Drama', image: 'drama.jpg' },
    { value: 'Mystery', image: 'mystery.jpg' },
    { value: 'Crime', image: 'crime.jpg' },
    { value: 'Animation', image: 'animation.jpg' },
    { value: 'Adventure', image: 'adventure.jpg' },
    { value: 'Fantasy', image: 'fantasy.jpg' },
    { value: 'Comedy-Romance', image: 'comedy-romance.jpg' },
    { value: 'Action-Comedy', image: 'action-comedy.jpg' },
    { value: 'Superhero', image: 'superhero.jpg' },
]

/* Sort Array by Preferences */
export function sortMoviesByFilter(movies , mood, genre) {

    let array1 = [];
    let moodcounts;
  
    (mood.length > 0) ? moodcounts = mood.length : moodcounts = 1;
  
    movies.forEach(function(movie, index) {
      if(movie.moviefeelings || movie.category){
        let countermoviefeelings = 0;
        let countermoviegenre = 0;
        const moviefeelingslength = movie.moviefeelings.length;
        const moviecategorylength = movie.category.length;
  
  
        movie.moviefeelings.forEach(function(value, index) {
          if(mood.includes(value[0].feeling.name)){ countermoviefeelings = countermoviefeelings +  1; }
        });   
  
        movie.category.forEach(function(item, index) {
          if(genre.includes(item.value)){ countermoviegenre = countermoviegenre +  1; }
        });
  
        let total = 0;
        let moodprocent = 0;
        let genreprocent = 0;
        (moviefeelingslength > 0) ? moodprocent = (countermoviefeelings / moviefeelingslength) * 70   : moodprocent = 0;
        (moviecategorylength > 0) ? genreprocent = (countermoviegenre / moviecategorylength) * 30   : genreprocent = 0;
  
  
        (countermoviegenre > 0) ? total = (parseFloat(countermoviefeelings) / moodcounts) * moodprocent + genreprocent : total = (parseFloat(countermoviefeelings) / moodcounts) * moodprocent + genreprocent;
        
        movie.procentege = parseFloat(total).toFixed(2);
        array1.push(movie);
      }
    });
  
    const data = array1.sort(function (a, b) {
      return b.procentege - a.procentege;
    });
  
    return data;
  }


  /* Randomize array in-place using Durstenfeld shuffle algorithm */
export function shuffleArray(array, countpreffered) {
    for (var i = countpreffered; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = array[i];
        array[i] = array[j];
        array[j] = temp;
    }
  }  
  
  /* Get Movie by Preferences */
export function getMovieInteres(movie, moviefeeling , mood, genre) {
  
    let moodcounts;
    let procentege;
  
    (mood.length > 0) ? moodcounts = mood.length : moodcounts = 1;
  
    if(moviefeeling || movie.category){
      let countermoviefeelings = 0;
      let countermoviegenre = 0;
      const moviefeelingslength = moviefeeling.length;
      const moviecategorylength = movie.category.length;
  
  
      moviefeeling.forEach(function(value, index) {
        if(mood.includes(value[0].feeling.name)){ countermoviefeelings = countermoviefeelings +  1; }
      });   
  
      movie.category.forEach(function(item, index) {
        if(genre.includes(item.value)){ countermoviegenre = countermoviegenre +  1; }
      });
  
      let total = 0;
      let moodprocent = 0;
      let genreprocent = 0;
      (moviefeelingslength > 0) ? moodprocent = (countermoviefeelings / moviefeelingslength) * 70   : moodprocent = 0;
      (moviecategorylength > 0) ? genreprocent = (countermoviegenre / moviecategorylength) * 30   : genreprocent = 0;
  
  
      (countermoviegenre > 0) ? total = (parseFloat(countermoviefeelings) / moodcounts) * moodprocent + genreprocent : total = (parseFloat(countermoviefeelings) / moodcounts) * moodprocent + genreprocent;
      
      procentege = parseFloat(total).toFixed(2);
  
      return procentege;
    }else{
      return 0;
    }
  }  